import React, { useEffect, useState } from "react";
import TableContainer from "../../../Component/TableContainer";
import { Box, Checkbox, IconButton, Switch, Typography } from "@mui/material";
import ResponsiveDialog from "../../../Component/ResponsiveDialog";
import { useSearchParams } from "react-router-dom";
import { masterAPI } from "../dataConfig";
import { axiosPrivate } from "../../../axios/axios";
import {useSelector} from "react-redux"
import {
  CheckCircle,
  DeleteOutline,
  EditOffOutlined,
  EditOutlined,
  RadioButtonUncheckedOutlined,
} from "@mui/icons-material";
import { color } from "../../../StyleData/Config";

import MeterGroupModal from "./MeterGroupModal";

const MeterGroup = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const actionsAllow=useSelector(state=>state.dataRed.actionsAllow)

  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [create, setCreate] = useState(false);
  const [mode, setMode] = useState("");
  const [editData, setEditData] = useState({});
  const [filterValue,setFilterValue]=useState("enableData")
  const [backUpData,setBackUpData]=useState([])

  useEffect(() => {
    getData();
  }, []);

  const getData = async() => {
    setIsLoading(true);
    const link = masterAPI["meterGroup"].link;
   await axiosPrivate
      .get(`${link}`)
      .then((res) => {
        res.data.result.sort((a, b) => {
          return a.code.localeCompare(b.code, undefined, {
            numeric: true,
            sensitivity: 'base'
          });
        });
        if(filterValue==="enableData"){
          const filterDataResult=res.data.result.filter(fil=>fil.isActive)
          console.log(filterDataResult, "locationresult");
          setData(filterDataResult);
          setBackUpData(res.data.result)
        }else{
          setData(res.data.result)
          setBackUpData(res.data.result)
        }
        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e, "meterGroup");
        setIsLoading(false);
        setData([])
        setBackUpData([])
      });
  };

  const handleButtonNew = () => {
    setMode("Create");
    setCreate(true);
  };
  const handleCreateClose = () => {
    setMode("");
    setCreate(false);
    getData();
  };

  const handleEdit = (data) => {
    setEditData(data);
    setMode("Edit");
    setCreate(true);
  };

  // const handleDelete = (id) => {
  //   const deleteLink = masterAPI["meterGroup"].delete;
  //   axiosPrivate
  //     .delete(`${deleteLink}/${id}`)
  //     .then((res) => {
  //       console.log(res.data);
  //       getData();
  //     })
  //     .catch((e) => {
  //       console.log(e, "deletemeterGroup");
  //     });
  // };

  const handleDelete = async(e,id,code) => {
    const enableLink = masterAPI["meterGroup"].enable;
    const disableLink = masterAPI["meterGroup"].disable;
    if(e.target.checked){
     await axiosPrivate
      .put(`${enableLink}/${id}/${code}`)
      .then((res) => {
        console.log(res.data);
        getData();
      })
      .catch((e) => {
        console.log(e, "enable ");
      });
    }else{
     await axiosPrivate
      .put(`${disableLink}/${id}/${code}`)
      .then((res) => {
        console.log(res.data);
        getData();
      })
      .catch((e) => {
        console.log(e, "disable ");
      });
    }
  };

  const columns = [
    {
      accessor: "id",
      disableFilters: true,
      Cell: () => {
        return (
          <Box sx={{width:color.checkBoxWidth }}>
          <Checkbox
            // icon={<RadioButtonUncheckedOutlined />}
            // checkedIcon={<CheckCircle />}
          />
          </Box>
        );
      },
    },
    {
      Header: "Meter Group Code",
      accessor: "code"
    },
    {
      Header: "Meter Group Name",
      accessor: "meterGroupName",
      // disableFilters: true,
    },
    
    {
      Header: "Actions",
      Cell: ({ cell }) => {
        // console.log(cell)
        return (
          <Box sx={{ whiteSpace: "nowrap" }}>
            <IconButton disabled={!actionsAllow.edit}>
              <EditOutlined
                onClick={() => {
                  handleEdit(cell.row.original);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: actionsAllow.edit? color.masterEditDelButtonColor:"default",
                }}
              />
            </IconButton>
            {/* <IconButton disabled={!actionsAllow.delete}>
              <DeleteOutline
                onClick={() => {
                  handleDelete(cell.row.original.id);
                }}
                sx={{
                  fontSize: color.masterEditDelButton,
                  color: actionsAllow.delete? color.masterEditDelButtonColor:"default",
                }}
              />
            </IconButton> */}
            <Switch
            disabled={!actionsAllow.delete}
            checked={cell.row.original.isActive}
            onChange={(e)=>{handleDelete(e,cell.row.original.id,cell.row.original.code)}}
           
             />
          </Box>
        );
      },
    },
  ];

  const handleChangeFilter=(e)=>{
   
    if(e==="showAll"){
      setData(backUpData)
    }else{
        const filterDataResult=backUpData.filter(fil=>fil.isActive)
        
        setData(filterDataResult);
    }
    setFilterValue(e)   
  }

  return (
    <>
      <Box>
        <Typography
          sx={{
            color: color.masterPageTitleColor,
            fontSize: color.masterPageTitleFontSize,
            fontWeight: color.masterPageTitleFontWeight,
            mb: color.masterPageTitlemd,
          }}
        >
          {masterAPI["meterGroup"].title}
        </Typography>
      </Box>
     
        <TableContainer
          columns={columns}
          data={data}
          buttonNew={handleButtonNew}
          loading={isLoading}
          buttonDisable={!actionsAllow.create}
          filterValue={filterValue}
          handleChange={handleChangeFilter}
          filterShow={true}
        />
   

      <ResponsiveDialog
        open={create}
        onClose={handleCreateClose}
        maxWidth={"md"}
        children={
          <MeterGroupModal
            handleCloseClick={handleCreateClose}
            mode={mode}
            editData={editData}
          />
        }
      />
    </>
  );
};

export default MeterGroup;
